import React, { useEffect, useState } from "react";
import app from "./base.js";
import { Spin } from "antd";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
	const [currentUser, setCurrentUser] = useState(null);
	const [pending, setPending] = useState(true);

	useEffect(() => {
		app.auth().onAuthStateChanged((user) => {
			setCurrentUser(user);
			setPending(false);
		});
	}, []);

	if (pending) {
		return (
			<div
				style={{
					alignItems: "center",
					justifyContent: "center",
					textAlign: "center",
					marginTop: 20,
					height: "100vh",
				}}
			>
				<Spin size="large"/>
			</div>
		);
	}

	return (
		<AuthContext.Provider
			value={{
				currentUser,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};
